import { render, staticRenderFns } from "./RouletteBoardLayout.vue?vue&type=template&id=247b46bd&scoped=true&"
import script from "./RouletteBoardLayout.vue?vue&type=script&lang=js&"
export * from "./RouletteBoardLayout.vue?vue&type=script&lang=js&"
import style0 from "./RouletteBoardLayout.vue?vue&type=style&index=0&id=247b46bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247b46bd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSystemBar } from 'vuetify/lib/components/VSystemBar';
installComponents(component, {VBtn,VSlideXTransition,VSpacer,VSystemBar})
